import * as React from "react";
import { Layout } from "../../layout";
import { Route, Routes } from "react-router-dom";
import { GvcList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { WorkloadDetailInitializer } from "../workload/detailInitializer";
import { VolumeSetDetailInitializer } from "../volumeset/detailInitializer";
import { GvcCreateInitializer } from "./create/initializer";
import { GvcDetailInitializer } from "./detailInitializer";
import { IdentityDetailInitializer } from "../identity/detailInitializer";

const GVCRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<GvcList />} />
        <Route path={`-create/*`} element={<GvcCreateInitializer />} />
        <Route path={`:gvc/identity/:identity/*`} element={<IdentityDetailInitializer />} />
        <Route path={`:gvc/volumeset/:volumeset/*`} element={<VolumeSetDetailInitializer />} />
        <Route path={`:gvc/workload/:workload/*`} element={<WorkloadDetailInitializer />} />
        <Route path={`:gvc/*`} element={<GvcDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default GVCRoute;
